import { create } from "../../../common/utils/zustand_state_manager";
import { IDiarioObraService } from "../../../features/diarioObra/data/services/diario_obra_service";
import { DiarioObraService } from "../../../features/diarioObra/data/services/diario_obra_service_impl";

//diarioObraService
type State = {
  diarioObraService: IDiarioObraService;
};

export const useDiarioObraServices = create<State>((set, get) => ({
  diarioObraService: new DiarioObraService(),
}));
